<template>
  <div class="tab-card-bd">
    <common-exclusive-service-card :exclusive-data="exclusiveData" @close="$emit('close')">
      <template #info>
        <div class="card-info">
          <div class="card-info-item" v-for="(info, index) in infoList" :key="index">
            <img :src="info.icon" alt="" class="info-icon">
            <span class="text" v-if="info.key === 'address'">{{ address }}</span>
            <span :class="['text', info.key === 'mobile_phone' ? 'link' : '']" v-else>{{ exclusiveData[info.key] }}</span>
          </div>
        </div>
      </template>
    </common-exclusive-service-card>

    <!-- <div class="tips">若点击联系我无法跳转，请扫描二维码添加签证专家</div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CommonExclusiveServiceCard from './common-exclusive-service-card.vue';
import linkPhoneImage from '@/assets/imgs/homepage/fixed-right-service/exclusive-service/link-phone.png';
import linkWxaImage from '@/assets/imgs/homepage/fixed-right-service/exclusive-service/link-wxa.png';
import linkEmailImage from '@/assets/imgs/homepage/fixed-right-service/exclusive-service/link-email.png';
import linkAddressImage from '@/assets/imgs/homepage/fixed-right-service/exclusive-service/link-address.png';
import pcdService from '@/services/pcd-service';

export default {
  props: {
    exclusiveData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    CommonExclusiveServiceCard,
  },
  data() {
    return {
      allInfoList: [
        {
          icon: linkPhoneImage,
          key: 'mobile_phone',
        },
        {
          icon: linkWxaImage,
          key: 'wechat_id',
        },
        {
          icon: linkEmailImage,
          key: 'email',
        },
        {
          icon: linkAddressImage,
          key: 'address',
        },
      ],
      address: '',
    };
  },
  created() {
    pcdService.getPcd().then((pcds) => {
      this.address = this.getAddress(pcds);
    }).catch((e) => {
      if (e) console.log(e);
    });
  },
  computed: {
    ...mapState('user', ['peerData']),
    infoList() {
      if (!this.exclusiveData) return [];
      // 查找有值的内容
      const infoList = [];
      this.allInfoList.forEach((info) => {
        const key = info.key;
        // 不需要判断的字段
        const noValidKeyList = ['address'];
        if (this.exclusiveData[key] || noValidKeyList.includes(key)) {
          infoList.push(info);
        }
      });

      return infoList;
    },
  },
  methods: {
    getAddress(pcds) {
      let address = '';
      if (this.peerData.province_code && this.peerData.city_code) {
        address = pcds[this.peerData.province_code][this.peerData.city_code] === '市辖区' ?
          `${pcds[86][this.peerData.province_code]}市区域专属` :
          `${pcds[this.peerData.province_code][this.peerData.city_code]}区域专属`;
      }
      return address;
    },
  },
};
</script>

<style lang="less" scoped>
.tab-card-bd {
  text-align: center;
  padding-bottom: 16px;
  position: relative;
  .card-info {
    padding: 20px 0 42px 0;
    display: inline-block;
    .card-info-item {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #2F333D;
      line-height: 14px;
      margin-top: 12px;
      &:first-child {
        margin-top: 0;
      }
      .info-icon {
        width: 16px;
        height: 16px;
        background: linear-gradient( 180deg, #8AC0FF 0%, #1F88FF 100%, #3AA5FF 100%);
        margin-right: 6px;
      }
      .text {
        &.link {
          color: #599FFF;
          text-decoration: solid;
          text-decoration-color: #599FFF;
        }
      }
    }

  }
  .tips {
    position: absolute;
    bottom: 24px;
    left: 0;
    right: 0;
    margin: 0 auto;
    font-size: 12px;
    color: #91999F;
    line-height: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fixed-right-service/components/dialog/exclusive-service-dialog/bd-exclusive-service-card.vue